const ProductCategory = {
  WETSTOCK: "wet-stock",
  DRYSTOCK: "dry-stock",
};

export default ProductCategory;
